import { useEffect, useState } from "react";
import styled from "styled-components";

import { useWindowDimensions } from "@utilities";
import { FooterComponent, FooterMobileComponent, ITag } from "@components";
import {
    PATH_MENU_SETTING,
    PATH_BOOKING,
    PATH_HOME,
    PATH_QUOTES,
    PATH_SEARCH_RESULT,
    PATH_MY_ACCOUNT,
    PATH_UPDATE_PASSWORD,
    PATH_FAVORITES,
} from "@routes";
import { getMetaData, selectAccount, selectAuth, useAppDispatch, useAppSelector } from "@redux";
import _ from "lodash";

export const FooterModule = () => {
    const { metadata } = useAppSelector(selectAccount);
    const { jwt } = useAppSelector(selectAuth);
    const { account } = useAppSelector(selectAccount);
    const [isSignedIn, setIsSignedIn] = useState(!_.isNil(jwt) && !_.isNil(account));
    const dispatch = useAppDispatch();

    useEffect(() => {
        setIsSignedIn(!_.isNil(jwt) && !_.isNil(account));
    }, [jwt, account]);

    useEffect(() => {
        if (isSignedIn) {
            dispatch(getMetaData());
        }
    }, [dispatch, isSignedIn]);

    const isOrderTabEnabled = Boolean(metadata?.is_order_tab_enabled);
    const { width } = useWindowDimensions();
    const [isBar, setIsBar] = useState<boolean>(false);
    const pathName = location.pathname;
    const tagBottom: ITag[] = [
        {
            Icon: "/images/Explore.svg",
            IconDark: "/images/ExploreDark.svg",
            text: "Explore",
            link: PATH_HOME,
        },
        {
            Icon: "/images/Booking.svg",
            IconDark: "/images/BookingDark.svg",
            text: "My Bookings",
            link: PATH_BOOKING,
        },
        {
            Icon: "/images/Cart.svg",
            IconDark: "/images/CartDark.svg",
            text: isOrderTabEnabled ? "Orders" : "Quotes",
            link: PATH_QUOTES,
        },
        {
            Icon: "/images/Profile.png",
            IconDark: "/images/ProfileDark.png",
            text: "Account",
            link: PATH_MENU_SETTING,
        },
    ];

    const [bottom, setBottom] = useState<ITag[]>(tagBottom);

    useEffect(() => {
        setBottom(
            tagBottom.map((tag) => {
                let active = false;
                if (pathName === PATH_SEARCH_RESULT) {
                    active = tag.link === PATH_HOME;
                } else {
                    active = pathName === tag.link;
                }
                return { ...tag, active };
            }),
        );

        if (
            pathName === PATH_HOME ||
            pathName === PATH_BOOKING ||
            pathName === PATH_MENU_SETTING ||
            pathName === PATH_QUOTES ||
            pathName === PATH_MY_ACCOUNT ||
            pathName === PATH_UPDATE_PASSWORD ||
            pathName === PATH_FAVORITES
        ) {
            setIsBar(true);
        }
    }, []);

    const isTestUser = Boolean(metadata?.is_test_user);

    /**
     * Tell the page when the mobile bottom bar is on screen.
     *
     * The chat launcher is injected by GTM rather than rendered here, and it
     * anchors itself to the bottom of the viewport — straight on top of the bar.
     * We cannot give it a prop, but a class on <body> lets GlobalStyles lift it,
     * and only on the pages that actually have a bar to clear.
     */
    useEffect(() => {
        const hasBottomBar = width < 767 && isBar;
        document.body.classList.toggle("has-bottom-bar", hasBottomBar);
        return () => document.body.classList.remove("has-bottom-bar");
    }, [width, isBar]);

    return (
        <>
            {width >= 767 ? (
                <FooterComponent />
            ) : isBar ? (
                <FooterMobileComponent tagList={bottom} />
            ) : null}
            {isTestUser && <TestUserBar>Test User Mode</TestUserBar>}
        </>
    );
};

const TestUserBar = styled.div`
    width: 100%;
    background-color: #000;
    color: #fff;
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    padding: 4px 0;
    letter-spacing: 0.5px;
    position: relative;
    z-index: 5;
`;
